import { put, takeLatest } from 'redux-saga/effects';

import { actions } from '../../utils/constants';
import { fetchCenters } from '../../utils/common-functions';

function* fetchAllCenters() {
    try {
        const centers = yield fetchCenters();
        yield put({ type: actions.CENTERS_FETCHED, payload: centers.data });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'As unidades não puderam ser carregados. Tente recarregar a página' } });
    }
}

export default function* classes() {
    yield takeLatest(actions.ASYNC_FETCH_ADMIN_DATA, fetchAllCenters);
}



// WEBPACK FOOTER //
// ./src/components/centers/centers.saga.js